<template>
  <b-modal
    :visible="visible"
    :title="editingGroup ? 'Editar agrupación' : 'Añadir agrupación'"
    :ok-title="editingGroup ? 'Guardar' : 'Crear'"
    cancel-title="Cancelar"
    cancel-variant="outline-secondary"
    @ok.prevent="handleSubmit"
    no-close-on-backdrop="true"
    @hidden="$emit('update:visible', false)"

  >
    <validation-observer ref="form">
      <b-form>
        <b-form-group label="Título" label-for="set-name">
          <validation-provider
            #default="{ errors }"
            name="Título"
            rules="required"
          >
            <b-form-input
              id="set-name"
              v-model="form.name"
              placeholder="Nombre de la agrupación"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group label="Descripción" label-for="set-description">
          <b-form-textarea
            id="set-description"
            v-model="form.description"
            placeholder="Descripción de la agrupación"
            rows="3"
          />
        </b-form-group>
        <b-form-group label="Horarios" label-for="set-schedules">
          <validation-provider
            #default="{ errors }"
            name="Horarios"
            rules="required"
          >
            <base-select
              v-model="form.schedules"
              :multiple="true"
              :searchable="true"
              :clearable="true"
              :resource="'/work-schedules'"
              :http-body="{ client_id: clientId }"
              placeholder="Selecciona horarios..."
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            v-model="form.is_active"
            switch
          >
            Activo
          </b-form-checkbox>
        </b-form-group>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import BaseSelect from '@/components/ui/select/BaseSelect.vue'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BaseSelect,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    clientId: {
      type: [Number, String],
      required: true,
    },
    editingGroup: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      required,
      form: {
        name: '',
        description: '',
        is_active: true,
        schedules: [],
      },
    }
  },
  watch: {
    visible(val) {
      if (val && this.editingGroup) {
        this.form = {
          name: this.editingGroup.name || '',
          description: this.editingGroup.description || '',
          is_active: this.editingGroup.is_active !== undefined ? !!this.editingGroup.is_active : true,
          schedules: this.editingGroup.work_schedules || this.editingGroup.schedules || [],
        }
      } else if (!val) {
        this.form = {
          name: '', description: '', is_active: true, schedules: [],
        }
      }
    },
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.$emit('submit', {
            client_id: this.clientId,
            name: this.form.name,
            description: this.form.description,
            is_active: this.form.is_active,
            work_schedule_ids: this.form.schedules.map(s => s.id),
          })
        }
      })
    },
  },
}
</script>
